/**
 * @desc 渠道退件明细列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.logisticsReturnRecord.getLogisticsReturnRecordDetailList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/logisticsReturnRecord/detailList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
